export default {"src":"/polygon/_next/static/media/halborn.5396ad7a.svg","height":88,"width":88};